export default {
  async getNews ({ commit }, perPage = 2) {
    const news = await this.$axios.$get(`https://www.credimaxx.de/wp-json/wp/v2/posts?per_page=${perPage}`)
    commit('updateNews', news)
  }
}
